import React, { useRef, useState } from 'react';
import { t } from './translations';

const T = { soft:'#8892a4' };

export default function SignaturePad({label,subLabel,onSign,signed,signerName,lang}){
  const canvasRef=useRef(null);
  const drawing=useRef(false);
  const lastPos=useRef(null);
  const [hasContent,setHasContent]=useState(false);

  const getPos=(e,canvas)=>{
    const rect=canvas.getBoundingClientRect();
    const src=e.touches?e.touches[0]:e;
    return{x:src.clientX-rect.left,y:src.clientY-rect.top};
  };
  const startDraw=(e)=>{
    e.preventDefault();
    drawing.current=true;
    const canvas=canvasRef.current;
    lastPos.current=getPos(e,canvas);
  };
  const draw=(e)=>{
    e.preventDefault();
    if(!drawing.current) return;
    const canvas=canvasRef.current;
    if(!canvas) return;
    const ctx=canvas.getContext('2d');
    if(!ctx) return;
    const pos=getPos(e,canvas);
    ctx.beginPath();
    ctx.moveTo(lastPos.current.x,lastPos.current.y);
    ctx.lineTo(pos.x,pos.y);
    ctx.strokeStyle='#e8f01a';
    ctx.lineWidth=2;
    ctx.lineCap='round';
    ctx.stroke();
    lastPos.current=pos;
  };
  const endDraw=()=>{
    drawing.current=false;
    const canvas=canvasRef.current;
    if(!canvas) return;
    const ctx=canvas.getContext('2d');
    if(!ctx) return;
    const data=ctx.getImageData(0,0,canvas.width,canvas.height);
    const hasInk=data.data.some((v,i)=>i%4===3&&v>0);
    setHasContent(hasInk);
  };
  const confirmSign=()=>{
    const canvas=canvasRef.current;
    if(!canvas) return;
    onSign(canvas.toDataURL());
  };
  const clear=()=>{
    const canvas=canvasRef.current;
    if(canvas){
      const ctx=canvas.getContext('2d');
      if(ctx) ctx.clearRect(0,0,canvas.width,canvas.height);
    }
    setHasContent(false);
    onSign(null);
  };

  return(
    <div style={{marginBottom:16}}>
      <div className="sec-lbl">{label}</div>
      {subLabel&&<div style={{fontSize:11,color:T.soft,marginBottom:8}}>{subLabel}</div>}
      {signed?(
        <div className="sig-pad signed">
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:20,marginBottom:4}}>✓</div>
            <div style={{fontSize:12,color:'#86efac',fontWeight:600}}>{t(lang,'signatureRecorded')}</div>
            {signerName&&<div style={{fontSize:11,color:T.soft,marginTop:2}}>{signerName}</div>}
          </div>
          <button onClick={clear} style={{position:'absolute',top:8,right:8,background:'rgba(239,68,68,0.2)',border:'1px solid rgba(239,68,68,0.3)',borderRadius:6,color:'#fc8181',fontSize:10,padding:'2px 7px',cursor:'pointer'}}>{t(lang,'deleteWord')}</button>
        </div>
      ):(
        <>
          <div style={{position:'relative'}}>
            <canvas ref={canvasRef} width={400} height={120}
              className="sig-pad"
              style={{width:'100%',display:'block',touchAction:'none'}}
              onMouseDown={startDraw} onMouseMove={draw} onMouseUp={endDraw} onMouseLeave={endDraw}
              onTouchStart={startDraw} onTouchMove={draw} onTouchEnd={endDraw}
            />
            {!hasContent&&(
              <div style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center',pointerEvents:'none'}}>
                <span style={{fontSize:12,color:'#4a5568'}}>{t(lang,'signHereText')}</span>
              </div>
            )}
          </div>
          {hasContent&&(
            <div style={{display:'flex',gap:8,marginTop:8}}>
              <button type="button" onClick={confirmSign} style={{flex:1,padding:'11px',background:'#e8f01a',color:'#0a0c0f',border:'none',borderRadius:10,fontWeight:700,fontSize:13,cursor:'pointer'}}>✓ {lang==='de'?'Unterschrift bestätigen':'Confirm signature'}</button>
              <button type="button" onClick={clear} style={{padding:'11px 18px',background:'rgba(239,68,68,0.1)',color:'#fc8181',border:'1px solid rgba(239,68,68,0.3)',borderRadius:10,fontWeight:700,fontSize:13,cursor:'pointer'}}>{lang==='de'?'Neu':'Redo'}</button>
            </div>
          )}
        </>
      )}
    </div>
  );
}